import { createGetApi, createPostApi } from 'friday-async';

class Apis {
  public getConfig = createGetApi<void>({
    url: '/homepage/config',
  });

  public save = createPostApi<{
    bannerIds: string[];
    hotActivityCodes: string[];
    hotNewsIds: string[];
    bottomMenuIds: string[];
    adSlot: { imageUrl: string; linkUrl: string };
  }>({
    url: '/homepage/save',
  });
}

export default Apis;
